import CancelUpdateProfile from './cancel_update_profile';

export default class CancelUpdatePhoneNumber extends CancelUpdateProfile {}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/cancel_update_phone_number.js